import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon, { ICON_NAMES } from 'components/Icon';


class TitleIcon extends Component {
  render() {
    const { children, color, align, withTm } = this.props;

    return (
      <div className={classNames("section-title-wrapper", {
        [`section-title-wrapper--${align}`]: align != null,
      })}>
        <Icon name={ICON_NAMES.symb} className={classNames("section-title-wrapper__icon", {
          [`section-title-wrapper__icon--${color}`]: color != null,
        })} />
        {
          withTm &&
          <Icon name={ICON_NAMES.tm} className={`section-title-wrapper__icon-tm util-fill-${color}`} />
        }
        {children}
      </div>
    )
  }
}

TitleIcon.propTypes = {
  children: PropTypes.any,
  color: PropTypes.oneOf(['green', 'white']),
  align: PropTypes.oneOf(['left', 'center']),
  withTm: PropTypes.bool,
};

TitleIcon.defaultProps = {
  color: 'green',
  align: 'left',
};

export default TitleIcon;